import { render, staticRenderFns } from "./Clan.vue?vue&type=template&id=21c33e21&scoped=true&"
import script from "./Clan.vue?vue&type=script&lang=js&"
export * from "./Clan.vue?vue&type=script&lang=js&"
import style0 from "./Clan.vue?vue&type=style&index=0&id=21c33e21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c33e21",
  null
  
)

export default component.exports